
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7 5H5a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M7 5a2 2 0 002 2h2a2 2 0 002-2M7 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m4 4H10m0 0l3-3m-3 3l3 3","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    